<template lang="pug">
base-section#home-overview(space='64')
  base-page-content
    .overview-shell
      .overview-intro
        base-display-title(
          :title='t("pages.home.overview.mark")'
          size='compact'
          tone='accent'
          :arrow='true'
        )
        h2.overview-title {{ t('pages.home.overview.title') }}
        p.overview-copy {{ t('pages.home.overview.body') }}
      .overview-grid
        article.overview-card(v-for='card in cards', :key='card.title')
          p.overview-card-index {{ card.index }}
          h3 {{ rt(card.title) }}
          p {{ rt(card.copy) }}
      .overview-statement
        p
          strong {{ t('pages.home.overview.statementStrong') }}
          |  {{ t('pages.home.overview.statement') }}
</template>

<script setup lang="ts">
defineOptions({
  name: 'SectionHomeOverview',
})

const { rt, t, tm } = useI18n()
const cards = computed(
  () => tm('pages.home.overview.cards') as Array<Record<string, string>>,
)
</script>

<style scoped>
#home-overview {
  background: linear-gradient(
    180deg,
    var(--surface-page) 0%,
    color-mix(in srgb, var(--surface-muted) 72%, white) 100%
  );
}

.overview-shell {
  display: grid;
  gap: 1.5rem;
}

.overview-intro {
  display: grid;
  gap: 0.8rem;
  max-width: 52rem;
}

.overview-title {
  margin: 0;
  font-size: clamp(2rem, 3.4vw, 3.2rem);
  line-height: 0.95;
  letter-spacing: -0.05em;
}

.overview-copy {
  margin: 0;
  color: var(--color-text);
  font-size: 1.02rem;
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.overview-card,
.overview-statement {
  padding: 1.2rem;
  border: 1px solid var(--border-default);
  background: var(--surface-card);
  border-radius: var(--radius-md);
}

.overview-card-index {
  margin: 0 0 0.8rem;
  color: var(--brand-primary);
  font-size: 0.74rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.overview-card h3 {
  margin: 0 0 0.55rem;
  font-size: 1.2rem;
  line-height: 1.1;
}

.overview-card p,
.overview-statement p {
  margin: 0;
  color: var(--color-text);
}

.overview-statement {
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--surface-card) 84%, var(--surface-muted)) 0%,
    var(--surface-card) 100%
  );
}

@media (max-width: 760px) {
  .overview-grid {
    grid-template-columns: 1fr;
  }
}
</style>
